import React, { useState, useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';

import ColorOption from './ColorOption';
import Primarytheme from './theme';

import axios from 'axios';
import { getFileFromS3 } from '../helpers/operations';
import CoordinatesAutocomplete from './CoordinatesAutocomplete';
import DatePickerCustomizable from './DatePickerCustomizable';
import AutocompleteMultival from './AutocompleteMultival';

import { getSessionIdToken } from '../auth/apiAuth'

const filter = createFilterOptions();

export default function Options({ conf, launch, setConf, isAdmin, auth }) {

    const handleChangeCheckOption = (idOpt, newValue) => {
        // console.log(idOpt, newValue)
        const newConf = { ...conf };
        newConf.selectedPaginationOptions[idOpt].value = newValue;
        setConf(newConf);
    }
    const renderCheckBoxList = (id, opt) => {
        const currentFileName = launch.selectedFile.name;
        const bucket = launch.projectData.bucket;
        const dataPath = launch.projectData.project_id + '/' + launch.projectData.dataFolder + '/' + launch.projectData.key;
        const project_id = launch.projectData.project_id;
        const reqId = launch.projectData.reqId;
        const newConf = { ...conf };
        let currentDate = new Date().toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
        let currentList = [];
        // console.log('currentList-init', currentList);

        if (newConf.selectedPaginationOptions[id].list) {
            currentList = newConf.selectedPaginationOptions[id].list;
            // console.log('currentList-alreadyexists', currentList);
            const exists = currentList.some(obj => obj && obj.name === currentFileName);
            if (!exists) {
                newConf.selectedPaginationOptions[id].list = [{ name: currentFileName, value: true, dateUpload: currentDate, bucket, dataPath, project_id, reqId }, ...currentList];
            } else {
                newConf.selectedPaginationOptions[id].list = newConf.selectedPaginationOptions[id].list.map((obj) => obj.name === currentFileName ? { ...obj, dateUpload: currentDate } : obj);
            }
        } else {
            // console.log('currentList-first', currentList);
            newConf.selectedPaginationOptions[id].list = [{ name: currentFileName, value: true, dateUpload: currentDate, bucket, dataPath, project_id, reqId }];
        }
        const updatedConf = { ...newConf };
        updateConf(updatedConf);
        currentList = updatedConf.selectedPaginationOptions[id].list;
        /* currentList.sort((a, b) => {
            const dateA = new Date(a.dateUpload.split(',').reverse().join(' '));
            const dateB = new Date(b.dateUpload.split(',').reverse().join(' '));
            return dateB - dateA; // per ordine decrescente
          }); */
        // console.log('currentList-final', currentList);


        return <Stack direction='column' alignItems='left' key={opt.nome + '2'}>
            {opt.type === 'datafiles-list' && currentList.map((file, idFile) => (
                <Stack direction='row' alignItems='left' justifyContent={'flex-start'} spacing={5} key={opt.nome + '3' + idFile}
                    divider={<Divider orientation="vertical" flexItem />}
                >
                    <FormControlLabel
                        sx={{ width: 500 }}
                        label={conf.selectedPaginationOptions[id].list[idFile].name}
                        key={file.name}
                        control={<Checkbox
                            key={file.name + 'check'}
                            checked={conf.selectedPaginationOptions[id].list[idFile].value}
                            onChange={(e) => handleChangeCheckOptionList(id, idFile, e.target.checked)}
                        />}
                    />
                    <Typography sx={{ alignContent: 'center', width: 200 }} key={file.name + 'date'} >
                        {conf.selectedPaginationOptions[id].list[idFile].dateUpload}
                    </Typography>
                    {file.name !== currentFileName && (
                        <Stack direction='row' alignItems='left' key={opt.nome + '4' + idFile}>
                            <Tooltip title="Cancella regola">
                                <IconButton key={file.name + 'del'} sx={{ padding: '0.5em' }} size="small" onClick={async () => await deleteCheckBoxItem(id, idFile, opt, file, auth)} ><DeleteIcon /></IconButton>
                            </Tooltip>
                            <Tooltip title="Download regola">
                                <IconButton size="small" sx={{ padding: '0.5em' }} onClick={() => getFileFromS3({ key: file.dataPath, bucket: file.bucket, customBucket: file.bucket, attachment: true, ssmParams: auth })}>
                                    < DescriptionIcon fontSize="small" />
                                </IconButton>
                            </ Tooltip >
                        </Stack>
                    )}
                </Stack>
            ))}
        </Stack>
    }
    const handleChangeCheckOptionList = (idOpt, idBlock, newValue) => {
        // console.log(idOpt, newValue)
        const newConf = { ...conf };
        newConf.selectedPaginationOptions[idOpt].list[idBlock].value = newValue;
        // console.log('update', newConf.selectedPaginationOptions[idOpt].list[idBlock])
        setConf(newConf);
    }
    const deleteCheckBoxItem = async (idOpt, idBlock, opt, file, auth) => {
        const newConf = { ...conf };
        newConf.selectedPaginationOptions[idOpt].list.splice(idBlock, 1);
        const updatedConf = { ...newConf };
        // console.log('del', newConf.selectedPaginationOptions[idOpt].list);

        // delete file in S3
        const reqId = file.reqId;
        const bucket = file.bucket;
        const project_id = file.project_id;
        axios.delete(`${process.env.REACT_APP_API_BASE_URL}/operations`, {
            headers: {
                "Authorization": await getSessionIdToken(),
                reqId,
                project_id,
                bucket,
                user_id: 'web-app'
            }
        })
            .then(response => {
                // console.log('resp del', response)
            }).catch(err => { })


        updateConf(updatedConf);
        setConf(updatedConf);
    }
    const handleFormList = (idOpt, idBlock, idSingle, newValue) => {
        const newConf = { ...conf };
        newConf.selectedPaginationOptions[idOpt].list[idBlock][idSingle].value = newValue;
        setConf(newConf)
    }
    const handleChangeAutocomplete = (idOpt, newValue, idBlock, idSingle) => {
        const newConf = { ...conf };
        if (idBlock !== undefined) {
            if (newValue) newConf.selectedPaginationOptions[idOpt].list[idBlock][idSingle].value = newValue;
            else newConf.selectedPaginationOptions[idOpt].list[idBlock][idSingle].value = newConf.selectedPaginationOptions[idOpt].list[idBlock][idSingle].default;
        } else {
            if (newValue) newConf.selectedPaginationOptions[idOpt].value = newValue;
            else newConf.selectedPaginationOptions[idOpt].value = newConf.selectedPaginationOptions[idOpt].default;
        }
        setConf(newConf)
    }

    const handleAdminBox = ({ property, newValue }) => {
        const newConf = { ...conf };
        newConf[property] = newValue;
        setConf(newConf)
    }

    const handleAdminQueueBox = ({ property, newValue }) => {
        const newConf = { ...conf };
        if (newValue) {
            newConf[property] = 'requests_vpc_test';
            setConf(newConf)
        } else {
            newConf[property] = 'requests_vpc';
            setConf(newConf)
        }
    }

    const handleChangeInDesignVersion = (newValue) => {
        const newConf = { ...conf };
        if (newValue) newConf.indesign_version = newValue;
        //else newConf.indesign_version = conf.indesign_version;
        setConf(newConf)
    }

    const handleChangeAutocompleteCreatable = (idOpt, newValue) => {
        const newConf = { ...conf };
        if (newValue) newConf.selectedPaginationOptions[idOpt].value = newValue;
        else {
            if (newConf.selectedPaginationOptions[idOpt].default) newConf.selectedPaginationOptions[idOpt].value = newConf.selectedPaginationOptions[idOpt].default;
            else newConf.selectedPaginationOptions[idOpt].value = null;
        }
        setConf(newConf)
    }

    const updateConf = async (updatedConf) => {
        const token = await getSessionIdToken();
        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_BASE_URL}/update-conf`,
            headers: {
                'Authorization': token,
                "content-type": "application/json",
            },
            data: JSON.stringify({ conf: updatedConf }),
            json: true
        }).then(response => {
            console.log('updated')
        })
            .catch(err => console.error('Update conf error'))
    }

    const handleAddOptionConf = (idOpt, inputValue) => {
        const newConf = { ...conf };

        if (inputValue) {
            if (newConf.customPaginationOptions?.[idOpt]?.custom_listAutocomplete) {
                if (newConf.customPaginationOptions[idOpt].custom_listAutocomplete.filter(t => t === inputValue).length === 0) {
                    newConf.customPaginationOptions[idOpt].custom_listAutocomplete = newConf.customPaginationOptions[idOpt].custom_listAutocomplete.concat([inputValue]);
                }
            } else {
                newConf.customPaginationOptions = {};
                newConf.customPaginationOptions[idOpt] = {};
                newConf.customPaginationOptions[idOpt].custom_listAutocomplete = [inputValue];
            }

            const updatedConf = { ...newConf };
            updateConf(updatedConf);
            setConf(updatedConf);
        }
    }

    const deleteOptionCreatable = (idOpt, delValue) => {
        const newConf = { ...conf };

        // update conf
        if (delValue && newConf.customPaginationOptions?.[idOpt]) {
            if (newConf.customPaginationOptions[idOpt].custom_listAutocomplete) {
                newConf.customPaginationOptions[idOpt].custom_listAutocomplete = newConf.customPaginationOptions[idOpt].custom_listAutocomplete.filter(t => t !== delValue);
            }

            const updatedConf = { ...newConf };
            updateConf(updatedConf);
            setConf(updatedConf);

            handleChangeAutocompleteCreatable(idOpt);
        }
    }

    const handleRenderOptionCreatable = (id, props, option) => {
        if (conf.customPaginationOptions?.[id]?.custom_listAutocomplete?.filter(t => t === option).length) {
            // option added manually
            return (
                <Stack direction='row' key={'stack' + option} alignItems='center'>
                    <Box component="li" sx={{ width: '100%' }} {...props}>{option}</Box><IconButton size="small" onClick={() => deleteOptionCreatable(id, option)} ><DeleteIcon /></IconButton>
                </Stack>
            )

        } else {
            const optionToPrint = option.name ? option.name : option;
            return <Box component="li" {...props}>{optionToPrint}</Box>
        }
    }

    useEffect(() => {
        function isEqual(obj1, obj2) {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every(key => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
        }

        function findOptionByName(options, targetName) {
            // Cerca tra le opzioni principali
            for (const opt of options) {
                if (opt.nome === targetName) return opt;

                // Cerca tra le opzioni annidate
                if (opt.list) {
                    for (const block of Object.values(opt.list)) {
                        for (const subOpt of Object.values(block)) {
                            if (subOpt.nome === targetName) return subOpt;
                        }
                    }
                }
            }

            return null;
        }

        const newConf = { ...conf };
        const options = newConf.selectedPaginationOptions;
        let changed = false;

        for (const [idOpt, opt] of Object.entries(options)) {
            // Opzione principale
            if (opt.visible && Array.isArray(opt.visible)) {
                let visible = false;

                for (const rule of opt.visible) {
                    const target = findOptionByName(options, rule.nome);
                    if (!target) continue;
                    const isTargetVisible = target.visibleCalc !== false;
                    if (!isTargetVisible) continue;


                    const values = Array.isArray(rule.value) ? rule.value : [rule.value];
                    const comparator = val => (typeof val === "object" && val !== null) ? isEqual(val, target.value) : val === target.value;


                    switch (rule.operator) {
                        case 'IS':
                            if (values.some(comparator)) visible = true;
                            break;
                        case 'NOT':
                            if (values.every(val => !comparator(val))) visible = true;
                            break;
                        default:
                            break;
                    }
                }

                if (opt.visibleCalc !== visible) {
                    options[idOpt] = { ...opt, visibleCalc: visible };
                    changed = true;
                }
            }

            // Sub-opzioni (list[idBlock][idSingle])
            if (opt.list) {
                for (const [idBlock, block] of Object.entries(opt.list)) {
                    for (const [idSingle, subOpt] of Object.entries(block)) {
                        if (subOpt.visible && Array.isArray(subOpt.visible)) {
                            let visible = false;

                            for (const rule of subOpt.visible) {
                                const target = findOptionByName(options, rule.nome);
                                if (!target) continue;
                                const isTargetVisible = target.visibleCalc !== false;
                                if (!isTargetVisible) continue;

                                const values = Array.isArray(rule.value) ? rule.value : [rule.value];
                                const comparator = val =>
                                    typeof val === 'object' ? isEqual(val, target.value) : val === target.value;

                                switch (rule.operator) {
                                    case 'IS':
                                        if (values.some(comparator)) visible = true;
                                        break;
                                    case 'NOT':
                                        if (values.every(val => !comparator(val))) visible = true;
                                        break;
                                    default:
                                        break;
                                }
                            }

                            if (subOpt.visibleCalc !== visible) {
                                newConf.selectedPaginationOptions[idOpt].list[idBlock][idSingle] = {
                                    ...subOpt,
                                    visibleCalc: visible
                                };
                                changed = true;
                            }
                        }
                    }
                }
            }
        }

        if (changed) {
            setConf(newConf);
        }
    }, [
        ...conf.selectedPaginationOptions.map(opt => opt.value),
        ...conf.selectedPaginationOptions.flatMap(opt =>
            opt.list
                ? Object.values(opt.list).flatMap(block =>
                    Object.values(block).map(subOpt => subOpt.value)
                )
                : []
        )
    ]);

    return (
        <Box>
            <Box sx={{ marginTop: '2em' }}>
                {conf.selectedPaginationOptions.map((opt, id) => {
                    if (opt.component === 'form') {
                        return (
                            <Stack direction='row' key={id} alignItems='center'
                                sx={{
                                    marginBottom: '2em',
                                    display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none',
                                }}>
                                <TextField
                                    label={opt.nome}
                                    size='small'
                                    value={conf.selectedPaginationOptions[id].value || ''}
                                    onChange={(e) => handleChangeCheckOption(id, e.target.value)}
                                    sx={{ width: opt.width }}
                                />
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>


                        )
                    }
                    if (opt.component === 'form-list') {
                        return (
                            <Box key={id} sx={{ display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <Typography  >
                                    <b>{opt.nome}</b>
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'left', flexWrap: 'wrap', listStyle: 'none', p: 0, m: 0 }}>
                                    {opt.list.map((block, idBlock) => (

                                        <Stack key={`${id}-${idBlock}`} direction='column' spacing={1} sx={{ mt: '1.5em', mr: '0.5em' }}>
                                            {block.map((singleOpt, idSingle) => (
                                                <li key={`li:${id}-${idBlock}-${idSingle}`}>
                                                    {(!singleOpt.component || singleOpt.component === 'form') && (
                                                        <Stack direction='column' alignItems='left' key={`${id}-${idBlock}-${idSingle}`} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.list[idBlock]?.[idSingle]?.visibleCalc !== false ? null : 'none' }}>
                                                            <TextField
                                                                key={singleOpt.nome}
                                                                label={singleOpt.nome}
                                                                size='small'
                                                                value={conf.selectedPaginationOptions[id].list[idBlock][idSingle].value}
                                                                onChange={(e) => handleFormList(id, idBlock, idSingle, e.target.value)}
                                                                sx={{ width: singleOpt.width, }}
                                                            />
                                                            <Typography variant='caption' >
                                                                {singleOpt.descrizione}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                    {singleOpt.component === 'autocomplete' && (
                                                        <Stack direction='column' alignItems='left' key={`${id}-${idBlock}-${idSingle}`} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.list[idBlock]?.[idSingle]?.visibleCalc !== false ? null : 'none' }}>
                                                            <Autocomplete
                                                                disablePortal
                                                                options={singleOpt.list}
                                                                sx={{ width: singleOpt.width }}
                                                                clearOnEscape
                                                                disableClearable={singleOpt.disableClearable}
                                                                value={conf.selectedPaginationOptions[id].list[idBlock][idSingle].value}
                                                                onChange={(event, value) => handleChangeAutocomplete(id, value, idBlock, idSingle)}
                                                                size='small'
                                                                renderInput={(params) => <TextField {...params} label={singleOpt.nome} />}
                                                            />
                                                            <Typography variant='caption' >
                                                                {singleOpt.descrizione}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                </li>

                                            ))}
                                        </Stack>
                                    ))}
                                </Box>
                            </Box>
                        )
                    }

                    if (opt.component === 'checkBox') {
                        //console.log('checkState = ', conf.selectedPaginationOptions[id].value)
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <FormControlLabel
                                    label={opt.nome}
                                    control={<Checkbox
                                        checked={conf.selectedPaginationOptions[id].value}
                                        onChange={(e) => handleChangeCheckOption(id, e.target.checked)}
                                    />}
                                />
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }

                    if (opt.component === 'checkBox-list') {
                        //console.log('checkState = ', conf.selectedPaginationOptions[id].value)
                        return (
                            <Box >
                                <Stack direction='column' alignItems='left' key={opt.nome + '1'} sx={{ marginBottom: '2em' }}>
                                    <Typography  >
                                        <b>{opt.nome}</b>
                                    </Typography>
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>
                                </Stack>
                                {opt.type === 'datafiles-list' && renderCheckBoxList(id, opt)}

                            </ Box>
                        )
                    }

                    if (opt.component === 'radio') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <Stack direction='row' justifyContent="flex-start" alignItems="center" >
                                    <FormControl>
                                        <RadioGroup
                                            name="flow-selector"
                                            value={conf.selectedPaginationOptions[id].value ? conf.selectedPaginationOptions[id].value : opt.default}
                                            onChange={(e) => handleChangeCheckOption(id, e.target.value)}
                                        >
                                            {conf.selectedPaginationOptions[id].radioSet.map(tag => <FormControlLabel key={tag} value={tag} control={<Radio />} label={<Typography color='textSecondary'>{tag}</Typography>} />)}
                                        </RadioGroup>
                                    </FormControl>
                                </Stack>
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }
                    if (opt.component === 'autocomplete') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <Autocomplete
                                    disablePortal
                                    options={opt.list}
                                    sx={{ width: opt.width }}
                                    clearOnEscape
                                    disableClearable={opt.disableClearable}
                                    value={conf.selectedPaginationOptions[id].value}
                                    onChange={(event, value) => handleChangeAutocomplete(id, value)}
                                    size='small'
                                    renderInput={(params) => <TextField {...params} label={opt.nome} />}
                                />
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }
                    if (opt.component === 'autocomplete-creatable') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <Autocomplete
                                    size='small'
                                    value={conf.selectedPaginationOptions[id].value}
                                    onChange={(event, newValue) => {
                                        if (typeof newValue === 'string') {
                                            handleChangeAutocompleteCreatable(id, newValue)
                                        } else if (newValue && newValue.inputValue) {
                                            // Create a new value from the user input
                                            handleChangeAutocompleteCreatable(id, newValue.inputValue);
                                            handleAddOptionConf(id, newValue.inputValue);
                                        } else {
                                            handleChangeAutocompleteCreatable(id, newValue)
                                        }
                                    }}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);

                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.name);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push({
                                                inputValue,
                                                name: `Add "${inputValue}"`,
                                            });
                                        }
                                        return filtered;
                                    }}
                                    selectOnFocus
                                    clearOnBlur
                                    clearOnEscape
                                    disableClearable={opt.disableClearable}
                                    handleHomeEndKeys
                                    id={id.toString()}
                                    options={[...opt.list, ...(conf.customPaginationOptions?.[id]?.custom_listAutocomplete ?? [])]}
                                    getOptionLabel={(option) => {
                                        // Value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                            return option;
                                        }
                                        // Add "xxx" option created dynamically
                                        if (option.inputValue) {
                                            return option.inputValue;
                                        }
                                        // Regular option
                                        return option.name;
                                    }}
                                    renderOption={(props, option) =>
                                        (handleRenderOptionCreatable(id, props, option))
                                    }

                                    sx={{ mr: '1em', mt: 0, width: opt.width }}
                                    freeSolo
                                    renderInput={(params) => <TextField {...params} label={opt.nome} />}
                                />
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }

                    if (opt.component === 'autocompleteMultival') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <AutocompleteMultival opt={opt} id={id} conf={conf} updateConf={updateConf} setConf={setConf}></AutocompleteMultival>
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }

                    if (opt.component === 'color') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <ColorOption handleChangeCheckOption={handleChangeCheckOption} opt={opt} id={id} conf={conf} />
                            </Stack>
                        )
                    }

                    if (opt.component === 'coordinatesAutocomplete') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <CoordinatesAutocomplete opt={opt} id={id} conf={conf} updateConf={updateConf} setConf={setConf}></CoordinatesAutocomplete>
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }

                    if (opt.component === 'DatePickerCustomizable') {
                        return (
                            <Stack direction='row' alignItems='center' key={opt.nome} sx={{ marginBottom: '2em', display: conf.selectedPaginationOptions[id]?.visibleCalc !== false ? null : 'none' }}>
                                <DatePickerCustomizable opt={opt} id={id} conf={conf} updateConf={updateConf} setConf={setConf}></DatePickerCustomizable>
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {opt.descrizione}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )
                    }
                })}
            </Box>

            {
                isAdmin && (
                    <Stack direction='column' key='only-admin'>
                        <Divider sx={{ mt: '1em', mb: '1em' }} />
                        <FormControlLabel key='only-admin'
                            label='internal test'
                            control={<Checkbox
                                checked={conf.internalTest}
                                onChange={(e) => handleAdminBox({ property: 'internalTest', newValue: e.target.checked })}
                            />}

                        />
                        <FormControlLabel key='onlyvalidation'
                            label='do only data integration'
                            control={<Checkbox
                                checked={conf.doOnlyValidation}
                                onChange={(e) => handleAdminBox({ property: 'doOnlyValidation', newValue: e.target.checked })}
                            />}

                        />
                        <FormControlLabel key='test-admin'
                            label='send to test queue (requests_vpc_test)'
                            control={<Checkbox
                                checked={conf.queue === 'requests_vpc_test'}
                                onChange={(e) => handleAdminQueueBox({ property: 'queue', newValue: e.target.checked })}
                            />}

                        />

                        {conf.queue === 'requests_vpc_test' && (
                            <Stack direction='row' alignItems='center' key={'indesign_version'} sx={{ marginBottom: '2em' }}>
                                <Autocomplete
                                    disablePortal
                                    options={[15, 16, 18]}
                                    sx={{ width: '25%' }}
                                    clearOnEscape
                                    disableClearable={true}
                                    value={conf.indesign_version}
                                    onChange={(event, value) => handleChangeInDesignVersion(value)}
                                    size='small'
                                    renderInput={(params) => <TextField {...params} label={'indesign_version'} />}
                                />
                                <Tooltip title={
                                    <Typography variant='caption' >
                                        {'Choose the InDesign version to use:'}<br></br>{'15 (2020)'}<br></br>{'16 (2021)'}<br></br>{'18 (2023)'}
                                    </Typography>}>
                                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                                </Tooltip>
                            </Stack>
                        )}
                    </Stack>
                )
            }

        </Box >

    )
}